import { Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { CategoriaProducto } from '../../categoria-producto/categoria-producto.model';
import { BackendService } from '../../../core/backend.service';
import { Observable } from 'rxjs';
import { SecurityService } from '../../../security/security.service';
import { ActivatedRoute } from '@angular/router';
import { Producto } from '../../producto.model';
import { SnackService } from '../../../shared-services/snack.service';
import { FormValidatorService } from '../../../shared-services/form-validator.service';
import { NgForm } from '@angular/forms';
import { ProductoListComponent } from '../../producto-list/producto-list.component';
import { ProductosBuscados } from './productosBuscados.models';
import { CategoriaProductoAddMassive } from './categoria-producto-add-massive.model';
import { NavigationService } from '../../../shared-services/navigation.service';

@Component({
  selector: 'app-categoria-producto-add-massive',
  templateUrl: './categoria-producto-add-massive.component.html',
  styleUrls: ['./categoria-producto-add-massive.component.scss']
})
export class CategoriaProductoAddMassiveComponent implements OnInit {
  @ViewChild('form') public productoForm: NgForm;
  @ViewChild('searchInput') searchInput: ElementRef;
  categorias: Observable<CategoriaProducto[]>;
  catepruebas: CategoriaProducto[] = [];
  productos: Observable<ProductosBuscados[]>;
  prodpruebas: ProductosBuscados[] = [];
  opcionesPais: string[] = ["ARGENTINA", "CHILE"]; 
  user: any;
  validationFail = false;
  updatesCategoriasProducto: CategoriaProductoAddMassive = new CategoriaProductoAddMassive();
  paisElegido: string;
  
  constructor(
    private backendService: BackendService,
    private authService: SecurityService,
    private route: ActivatedRoute,
    private snackService: SnackService,
    private formValidatorService: FormValidatorService,
    private navigationService: NavigationService,
  ) {}

  ngOnInit() {
    this.user = this.authService.user;
    this.getCategorias();
  }

  async validateForm() {

    if (this.catepruebas.length == 0) {
      this.snackService.error("Por favor, cargue al menos una categoría.");
      return;
    }
    if (this.prodpruebas.length == 0) {
      this.snackService.error("Por favor, cargue al menos un producto.");
      return;
    }
    await this.guardar();
  }

  async getCategorias() {
   this.categorias = this.backendService.get(CategoriaProducto, CategoriaProducto.path + 'todos', {});
  }
  async getProductos(pais: string) {
    this.productos = this.backendService.get(ProductosBuscados, ProductosBuscados.path + "all-producto-pais/" + pais, null);
  }

  async guardar() {
    try {
      this.snackService.spinner(true);
      this.updatesCategoriasProducto.categorias = this.catepruebas;
      this.updatesCategoriasProducto.productos = this.prodpruebas;
      await this.backendService.update(CategoriaProductoAddMassive.path + "update-categoria-producto-massive", this.updatesCategoriasProducto).then(a=>{
        this.snackService.success("Se cargaron las categorías correctamente");
      })
      
    } catch (ex) {
      this.snackService.error("Fallo la carga de categorías");
    } finally {
      this.snackService.spinner(false);
    }
  }

  back () {
    this.catepruebas = [];
    this.prodpruebas = [];
    this.paisElegido = '';
  }
  
  compareFn (c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

}



// WEBPACK FOOTER //
// ./src/app/productos/carga-masiva/categoria-producto-add-massive/categoria-producto-add-massive.component.ts